import React, { Component } from "react";
import { View, StyleSheet, TouchableOpacity, Text, Pressable, TouchableHighlightBase  } from "react-native";
import { Data, OBData, OrdData, PosData } from "../~Utilities/Data";
import { AppMain, BookItem, FontInfo, } from "../~Utilities/Constants";
import {StringTable} from '../StringTable';
import OBLastPrice from "../C_Text/OBLastPrice";
import OBStaticStyleText from "../C_Text/OBStaticStyleText";
import { Connection, ConnectionMkt, ConnectionOrd, ISettings } from "../~Utilities/Connection";
import OBNakedText from "../C_Text/OBNakedText";
import OBChange from "../C_Text/OBChange";
import Utilities from '../~Utilities/Utilities';
import QB from "./QB";
import OBTop from "./OBTop";
import OBBottom from "./OBBottom";
import OBMaxButton from "./OBMaxButton";
import OrderWoOrder from '../C_Popups/OrderWoOrder';
import { PriceType, TransactionType } from "../~Utilities/Rq";
import OBOrder from "../C_General/OBOrder";
import Draggable from "../C_General/Draggable";
import OBModify from "../C_General/OBModify";
import { ScrollView } from "react-native-gesture-handler";
import Order from "../C_Popups/SettingsAndOrders";
import { TOUCHABLE_STATE } from "react-native-gesture-handler/lib/typescript/components/touchables/GenericTouchable";
import App from "../../../App";
import { isTSExternalModuleReference } from "@babel/types";
import { Feather, Fontisto } from "@expo/vector-icons";

/*   ====================================================================   */

export interface IOBInfo
{
    oData      : Data;
    iSettIndex : number;
    qbRef?     : React.RefObject<QB>;
    //Remove    : (sToken: string)=>void;
    bindEvent  : (onEvent    : (() => void),
                 bSubscribe : boolean) => void
}

// export interface IOBState
// {
//   visible   : boolean;
//   bookRef   : FlatList;
// }

/*   ====================================================================   */

export interface IOBState
{
  visible     : boolean;
  scroll      : boolean;
  height      : number;
  //expanded    : boolean;
}

/*   ====================================================================   */

// export interface IOBState
// {
//   visible   : boolean;
//   bookRef   : FlatList;
// }

/*   ====================================================================   */

export class OCO
{
public sId        : string;
public iLowLevel  : number;
public iHighLevel : number;
public iTxn       : number;

constructor(sId    : string,
            iLevel : number,
            iTxn   : number)
{
this.sId        = sId;
this.iLowLevel  = iLevel;
this.iHighLevel = iLevel;
this.iTxn       = iTxn;
}
}

/*   ====================================================================   */

export default class OB extends Component<IOBInfo>
 {
  static              WHITE_HEIGHT  = 0;

  state : IOBState = {visible: false, 
                      scroll: true, 
                      height: 382, };
                      //expanded: false};  //0};

  public bookRef?         : ScrollView   | any;
  private m_y             = 0;
  // public orderWoOrderRef? : OrderWoOrder | null;
  public obTop?           : OBTop | null;
  public obBottom?        : OBBottom | null;
  public obMaxButton?     : OBMaxButton | null;

  private oOBData         : OBData  | undefined = undefined;
  public oOBLevels        : BookItem[] | undefined = undefined;
  private oPosData        : PosData | undefined = undefined;

  public  obOrderRef      : OBOrder[]     = new Array(0);
  private obPriceRef      : OBLastPrice[] = new Array(0);

  //public containerRef : View | null = null;
  public center           = 50;
  //public center_current = AppMain.IMAGINARY;
  public visibleItems     = 0;
  public ITEM_HEIGHT      = 14;
  public bOBCentered      = false;
  public static iWDelta   = (350 - Utilities.WIDTH)/5;

  public oOBModify        : OBModify | null = null;

  private dAvgFillPrice   : number | undefined;
  private iAvgFillPrLevel : number | undefined;
  private bUpdateBracket? : boolean;
  private bExpanded       : boolean;
  private iSCROLL_HEIGHT  : number = 350;

  /*   -------------------------------------------------------------------   */

  constructor(props)
  {
  super(props);

  this.UpdateData          = this.UpdateData.bind(this);
  this.Hide                = this.Hide.bind(this);
  this.Show                = this.Show.bind(this);
  this.SetCenter           = this.SetCenter.bind(this);
  this.CenterBook          = this.CenterBook.bind(this);
  this.onClickBuy          = this.onClickBuy.bind(this);
  this.onClickSell         = this.onClickSell.bind(this);
  this.onClickSell         = this.onClickSell.bind(this);
  this.onOrderEvent        = this.onOrderEvent.bind(this);
  this.SelectAccount       = this.SelectAccount.bind(this);
  this.SelectAccountForce  = this.SelectAccountForce.bind(this);
  this.PopulateOrders      = this.PopulateOrders.bind(this);
  this.IsCurrent           = this.IsCurrent.bind(this);
  this.UpdateFont          = this.UpdateFont.bind(this);
  this.ClearAllOrders      = this.ClearAllOrders.bind(this);
  this.RefreshOrders       = this.RefreshOrders.bind(this);
  this.RefreshOrdersOnBkt  = this.RefreshOrdersOnBkt.bind(this);
  this.GetPartialLevels    = this.GetPartialLevels.bind(this);
  this.preRender           = this.preRender.bind(this);
  this.onPriceLayout       = this.onPriceLayout.bind(this);

  let z : number;

  if (this.props.iSettIndex < ConnectionOrd.oSettings.length &&
    ConnectionOrd.oSettings[this.props.iSettIndex].token == this.props.oData.token)
    z = this.props.iSettIndex;
  else
    z = Utilities.FindItem(ConnectionOrd.oSettings, this.props.oData.token);

  this.state = {visible: false, 
                scroll: true, 
                height:OB.WHITE_HEIGHT,};
                //expanded: (z != AppMain.IMAGINARY && ConnectionOrd.oSettings[z].bOBExpanded)? true : false};



  this.bExpanded = (z != AppMain.IMAGINARY && ConnectionOrd.oSettings[z].bOBExpanded)? true : false;

  // let oSett      : ISettings | undefined;
  // let sSvAccount : string | undefined;

  // //alert(this.sSvAccount)
  // //Utilities.Sendlog("Saved account: " + this.sSvAccount + " " + this.props.oData.token);

  // if (z != AppMain.IMAGINARY)
  //   {
  //   oSett      = ConnectionOrd.oSettings[z];
  //   sSvAccount = oSett?.sAccount;
  //   }

  this.oPosData  = ConnectionOrd.GetPosData(this.props.oData, this.props.oData.sv_account);
  }

  /*   -------------------------------------------------------------------   */

  UpdateData()
  {
  if (this.bUpdateBracket)
    {
    this.RefreshOrdersOnBkt();
    this.bUpdateBracket = false;
    }


  // if (this.oOBData == undefined)
  //   {
  //   this.preRender();
  //   }

  if (this.oPosData?.avg_open_fillprice && this.oOBData)
    {
    if (this.oPosData.net_qty == 0 ||
        this.dAvgFillPrice    != this.oPosData?.avg_open_fillprice)
      {
        if (this.iAvgFillPrLevel)
          {
          //let iLevel = ConnectionMkt.GetOBLevel(this.oOBData, this.dAvgFillPrice);

          //if (iLevel != AppMain.IMAGINARY)
            this.obPriceRef[this.iAvgFillPrLevel]?.SetAvgOpenFillPrice(false);

            if (__DEV__)
              Utilities.Sendlog("Removing at: " + this.iAvgFillPrLevel);

            this.iAvgFillPrLevel = undefined;
            this.dAvgFillPrice   = undefined;
          }

        if (this.oPosData.net_qty == undefined || this.oPosData.net_qty == 0)
          return;

        let dAvgPrice = this.oPosData?.avg_open_fillprice;
        let dAvgTicks = dAvgPrice/this.props.oData.qpc;
        let dPrice;

        if (this.oPosData.net_qty > 0)
          dPrice = (Math.ceil(dAvgTicks) * this.props.oData.qpc);
        else
          dPrice = (Math.floor(dAvgTicks) * this.props.oData.qpc);

        //let iLevel = ConnectionMkt.GetOBLevel(this.oOBData, dPrice);
        let iLevel = ConnectionMkt.GetOBLevelAlt(this.oOBLevels?
                                                 this.oOBLevels[0].Price : undefined,
                                                 dPrice,
                                                 this.props.oData);

        if (iLevel != AppMain.IMAGINARY && this.obPriceRef[iLevel])
          {
          this.iAvgFillPrLevel = iLevel;
          this.dAvgFillPrice   = this.oPosData?.avg_open_fillprice; //dPrice;
          this.obPriceRef[iLevel].SetAvgOpenFillPrice(true);

          if (__DEV__)
            Utilities.Sendlog("Setting at: " + this.iAvgFillPrLevel);
          }
      }
    }
  }

  /*   -------------------------------------------------------------------   */

  Hide()
  {
  this.setState({visible:false, height:382})
  }

  /*   -------------------------------------------------------------------   */

  Show()
  {
  //alert(OB.WHITE_HEIGHT);
  this.preRender();

  if (this.state.visible == false)
    this.setState({visible:true})
  }

  /*   -------------------------------------------------------------------   */

  UpdateFont()
  {
  if (this.state.height != OB.WHITE_HEIGHT)
    this.setState({height: OB.WHITE_HEIGHT})
  }

  /*   -------------------------------------------------------------------   */

  SetCenter(center : number)
  {
  // if (this.center == center)
  //   return;

  this.center = center;
  //console.log("set center: " + center);
  //this.CenterBook();
  if (this.center < 0)
    {
    if (__DEV__)      
      Utilities.Sendlog("invalid center: " + center);
    }
  }

  /*   -------------------------------------------------------------------   */

  onClickBuy(item : BookItem)
  {
  this.props.qbRef?.current?.oOrderRef?.ShowBuyConf("Order Book, Buy Price Tap",
                                                    PriceType.LIMIT,
                                                    item.Price)
  }

  /*   -------------------------------------------------------------------   */

  onClickSell(item : BookItem)
  {
  this.props.qbRef?.current?.oOrderRef?.ShowSellConf("Order Book, Sell Price Tap",
                                                     PriceType.LIMIT,
                                                     item.Price)
  }

  /*   -------------------------------------------------------------------   */

  SelectAccount(oData : PosData)
  {
  if (__DEV__)    
    Utilities.Sendlog("***OB Setting account called");

  if (this.oPosData?.acc_key != oData.acc_key)
    {
    if (this.oPosData)
      {
      this.oOBModify?.Hide();

      for (let i = 0; i < this.obOrderRef.length; i++)
        this.obOrderRef[i].ClearAllOrders();
      }


    this.oPosData = oData;

    this.PopulateOrders(true);

    if (__DEV__)
      Utilities.Sendlog("***OB Setting account: " + this.oPosData?.acc_key + " ob levels: " + this.obOrderRef.length);
    }
  }

  /*   -------------------------------------------------------------------   */

  SelectAccountForce(oData : PosData)
  {
  if (__DEV__)    
    Utilities.Sendlog("***OB Setting account called");

  if (this.oPosData?.acc_key != oData.acc_key ||
      this.oPosData?.token   != oData.token)
    {
    if (this.oPosData)
      {
      this.oOBModify?.Hide();

      for (let i = 0; i < this.obOrderRef.length; i++)
        this.obOrderRef[i].ClearAllOrders();
      }


    this.oPosData = oData;

    this.PopulateOrders(true);

    if (__DEV__)
      Utilities.Sendlog("***OB Setting account: " + this.oPosData?.acc_key + " ob levels: " + this.obOrderRef.length);
    }
  }

  /*   -------------------------------------------------------------------   */

  PopulateOrders(bForce  : boolean,
                 oSelIds : string[] = new Array(0))
  {
  if (!this.oPosData)
    {

    if (this.obBottom?.orderWoOrderRef?.state.pos_data)
      this.SelectAccount(this.obBottom?.orderWoOrderRef?.state.pos_data);

    return;
    }

  if (this.oPosData &&
      this.oOBData  &&
      this.obOrderRef.length != 0)
    {
    if (__DEV__)      
      Utilities.Sendlog("***OB Populate Orders: " + this.oPosData?.acc_key + " obdata: " + this.oOBData?.book.length + " ob levels: " + this.obOrderRef.length);

    //this.oOBModify?.Hide();

    if (!this.oOBLevels)
      return;

    let oOCOs : OCO[] | undefined = undefined;

    for (let i = 0; i < this.oPosData.orders_working.length; i++)
      {
      let oOrdData = ConnectionOrd.oOrdStore.
                      get(this.oPosData.orders_working[i]);

      if (oOrdData)
        {
        let dPrice;

        if (oOrdData.price_type_api == PriceType.LIMIT)
          dPrice = oOrdData.limit_price;
        else
          dPrice = oOrdData.trigger_price;

        //let iLevel = ConnectionMkt.GetOBLevel(this.oOBData, dPrice);
        let iLevel = ConnectionMkt.GetOBLevelAltUnbridled(this.oOBLevels[0].Price,
                                                          dPrice,
                                                          this.props.oData);

        //if (iLevel != AppMain.IMAGINARY)
          {
          if (iLevel >= 0 && iLevel < this.oOBLevels.length)
            {
            this.obOrderRef[iLevel].UpdateOrder(oOrdData, bForce, OB.IsSelected(oSelIds, oOrdData));

            if (oOrdData.linked_orders)
              this.obOrderRef[iLevel].UpdateLines({bHzLineOCO: true});
            }

          if (oOrdData.linked_orders)
            {
            if (!oOCOs)
              {
              oOCOs = new Array(0);
              oOCOs.push(new OCO(oOrdData.linked_orders, iLevel, oOrdData.txn_type_api));
              }
            else
              {
              let z = -1;

              for (let j = 0; j < oOCOs.length; j++)
                {
                if (oOCOs[j].sId == oOrdData.linked_orders)
                  {
                  z = j;

                  if (oOCOs[j].iLowLevel > iLevel)
                    oOCOs[j].iLowLevel = iLevel;

                  if (oOCOs[j].iHighLevel < iLevel)
                    oOCOs[j].iHighLevel = iLevel;

                  if (oOrdData.txn_type_api != oOCOs[j].iTxn)
                    oOCOs[j].iTxn = AppMain.IMAGINARY;

                  break;
                  }

                if (z == AppMain.IMAGINARY)
                  {
                  oOCOs.push(new OCO(oOrdData.linked_orders, iLevel, oOrdData.txn_type_api));
                  }
                }
              }

            //this.obOrderRef[iLevel]?.UpdateLines({bHzLineOCO: true});
            }
          }

        if (oOrdData.bracket_type)
          {
          this.PopulateBrackets(oOrdData, dPrice, bForce, oSelIds, iLevel);
          }
        }
      }

    /*   -----------------------------------------------------------------   */

    if (!oOCOs)
      return;

    for (let i = 0; i < oOCOs.length; i++)
      {
      if (oOCOs[i].iHighLevel == oOCOs[i].iLowLevel || oOCOs[i].iHighLevel < 0)
        continue;
       
      let iMax = oOCOs[i].iHighLevel >= this.obOrderRef.length? this.obOrderRef.length - 1:
                                        oOCOs[i].iHighLevel;
      
      for (let j = oOCOs[i].iLowLevel < 0? 0 : oOCOs[i].iLowLevel; j <= iMax; j++)
        {
        this.obOrderRef[j].UpdateLines({bVtUpLineOCO: j==oOCOs[i].iLowLevel? undefined : true,
                                        bVtDnLineOCO: j==oOCOs[i].iHighLevel? undefined : true,
                                        sOCOColor:oOCOs[i].iTxn == AppMain.IMAGINARY? 
                                        'limegreen' : oOCOs[i].iTxn == TransactionType.BUY? 
                                        'dodgerblue' : 'hotpink'});
        }
      }
    }
  }

  /*   -------------------------------------------------------------------   */

  PopulateOrdersBkt(bForce  : boolean,
                    oSelIds : string[])
  {
  if (!this.oPosData)
    {

    if (this.obBottom?.orderWoOrderRef?.state.pos_data)
      this.SelectAccount(this.obBottom?.orderWoOrderRef?.state.pos_data);

    return;
    }

  if (this.oPosData &&
      this.oOBData  &&
      this.obOrderRef.length != 0)
    {
    if (__DEV__)
      Utilities.Sendlog("***OB Populate Orders: " + this.oPosData?.acc_key + " obdata: " + this.oOBData?.book.length + " ob levels: " + this.obOrderRef.length);

    //this.oOBModify?.Hide();

    for (let i = 0; i < this.oPosData.orders_working.length; i++)
      {
      let oOrdData = ConnectionOrd.oOrdStore.
                      get(this.oPosData.orders_working[i]);

      if (oOrdData)
        {
        let dPrice;

        if (oOrdData.price_type_api == PriceType.LIMIT)
          dPrice = oOrdData.limit_price;
        else
          dPrice = oOrdData.trigger_price;

        //let iLevel = ConnectionMkt.GetOBLevel(this.oOBData, dPrice);
        let iLevel = ConnectionMkt.GetOBLevelAlt(this.oOBLevels?
                                                 this.oOBLevels[0].Price : undefined,
                                                 dPrice,
                                                 this.props.oData);

        if (iLevel != AppMain.IMAGINARY)
          this.obOrderRef[iLevel].UpdateOrder(oOrdData, bForce, OB.IsSelected(oSelIds, oOrdData) );

        if (oOrdData.bracket_type)
          {
          this.PopulateBrackets(oOrdData, dPrice, bForce, oSelIds, iLevel);
          }
        }
      }
    }
  }

  /*   -------------------------------------------------------------------   */

    static MatchBasketId(www    : string[],
                         oData  : OrdData) : boolean
    {
    for (let i = 0; i < www.length; i++)
      {
      if (www[i] == oData.basket_id)
        {
        return(true);
        }
      }

    return(false);
    }

    /*   -----------------------------------------------------------------   */

    static MatchSelId(www    : string[],
                      oData  : OrdData) : boolean
    {
    for (let i = 0; i < www.length; i++)
      {
      if (www[i] == oData.sSelId)
        {
        return(true);
        }
      }

    return(false);
    }

    /*   -----------------------------------------------------------------   */

  static IsSelected(oSelIds : string[],
                    oData   : OrdData)
  {
  if (oSelIds.length == 0)
    return(false);

  if (oData.sSelId)
    return(OB.MatchSelId(oSelIds, oData));
  else
    return(OB.MatchBasketId(oSelIds, oData));
  }

  /*   -------------------------------------------------------------------   */

  PopulateBrackets(oOrdData : OrdData,
                   dPrice   : number,
                   bForce   : boolean,
                   oSelIds  : string[],
                   ipLevel  : number)
  {
  let oBr = Connection.oBrackets.get(oOrdData.basket_id);

  /*   -------------------------------------------------------------------   */

  if (oBr == undefined || !this.oOBLevels)
    return;

  /*   -------------------------------------------------------------------   */

  let iTxn        : number;
  let iDirTgt     : number;
  let iDirStp     : number;
  let dLPrice     : number;
  let iLevel      : number;
  let oLData      : OrdData;
  let sLineColor  : string;
  let iLowLine    : number | undefined  = undefined; //ipLevel != -1? ipLevel : 1000;
  let iHighLine   : number | undefined  = undefined; //ipLevel != -1? ipLevel : 0;

  /*   -------------------------------------------------------------------   */

  if (oOrdData.txn_type_api == TransactionType.BUY)
    {
    iTxn       = TransactionType.SELL;
    iDirTgt    = 1;
    iDirStp    = AppMain.IMAGINARY;
    sLineColor = 'hotpink';
    }
  else
    {
    iTxn       = TransactionType.BUY;
    iDirTgt    = AppMain.IMAGINARY;
    iDirStp    = 1;
    sLineColor = 'dodgerblue';
    }

  /*   -------------------------------------------------------------------   */

  for (let i = 0; i < oBr.targets.length; i++)
    {
    // if (!this.oOBLevels)
    //   return;

    dLPrice = dPrice + (iDirTgt * oBr.targets[i].level * this.props.oData.qpc);

    iLevel  = ConnectionMkt.GetOBLevelAltUnbridled(this.oOBLevels[0].Price,
                                                   dLPrice,
                                                   this.props.oData);


    if (iLowLine == undefined || iLevel < iLowLine)
      iLowLine = iLevel;

    if (iHighLine == undefined || iLevel > iHighLine)
      iHighLine = iLevel;

    if (iLevel < 0 || iLevel >= this.oOBLevels.length)
      continue;

    oLData           = new OrdData();
    oLData.basket_id = oOrdData.basket_id;
    oLData.qty       = (oBr.targets[i].qty_org - oBr.targets[i].qty_rel)

    oLData.txn_type_api   = iTxn;
    oLData.acc_key        = oOrdData.acc_key;
    oLData.price_type_api = PriceType.LIMIT;
    oLData.limit_price    = dPrice;
    oLData.oBrData        = oBr.targets[i];
    oLData.sSelId         = oOrdData.basket_id + "L" +  i;


    this.obOrderRef[iLevel].UpdateOrder(oLData,
                                        bForce,
                                        OB.IsSelected(oSelIds, oLData),
                                        {bHzLineBr:true} );
    }

  /*   -------------------------------------------------------------------   */

  for (let i = 0; i < oBr.stops.length; i++)
    {
    dLPrice = dPrice + (iDirStp * oBr.stops[i].level * this.props.oData.qpc);

    iLevel  = ConnectionMkt.GetOBLevelAltUnbridled(this.oOBLevels[0].Price,
                                                   dLPrice,
                                                   this.props.oData);

    // if (iLevel == AppMain.IMAGINARY)
    //   continue;

    if (iLowLine == undefined || iLevel < iLowLine)
      iLowLine = iLevel;

    if (iHighLine == undefined || iLevel > iHighLine)
      iHighLine = iLevel;

    if (iLevel < 0 || iLevel >= this.oOBLevels.length)
      continue;

    oLData           = new OrdData();
    oLData.basket_id = oOrdData.basket_id;
    oLData.qty       = (oBr.stops[i].qty_org - oBr.stops[i].qty_rel)

    oLData.txn_type_api   = iTxn;
    oLData.acc_key        = oOrdData.acc_key;
    oLData.price_type_api = PriceType.STOP_LIMIT;
    oLData.limit_price    = dPrice;
    oLData.oBrData        = oBr.stops[i];
    oLData.sSelId         = oOrdData.basket_id + "S" + i;

    // if (iLevel < iLowLine)
    //   iLowLine = iLevel;

    // if (iLevel > iHighLine)
    //   iHighLine = iLevel;

    this.obOrderRef[iLevel].UpdateOrder(oLData,
                                        bForce,
                                        OB.IsSelected(oSelIds, oLData),
                                        {bHzLineBr:true});
    }

  /*   -------------------------------------------------------------------   */

  if (ipLevel != AppMain.IMAGINARY)
    this.obOrderRef[ipLevel]?.UpdateLines({bHzLineBr:true});

  /*   -------------------------------------------------------------------   */

  if (iLowLine == undefined || iHighLine == undefined || iHighLine < 0)
    return;

  let iMax = iHighLine >= this.obOrderRef.length? this.obOrderRef.length - 1:
                                                  iHighLine;

  for (let i = iLowLine < 0? 0 : iLowLine; i <= iMax; i++)
    {
    this.obOrderRef[i]?.UpdateLines({bVtUpLineBr: i==iLowLine? undefined : true,
                                     bVtDnLineBr: i==iHighLine? undefined : true,
                                     sBrColor:sLineColor});
    }
  }

  /*   -------------------------------------------------------------------   */

  RefreshOrders()
  {
  if (this.oPosData && this.obOrderRef)
    {
    for (let i = 0; i < this.obOrderRef.length; i++)
      {
      this.obOrderRef[i].DisableCancel(true);
      this.obOrderRef[i].ClearAllOrders();
      }
    }

  this.oOBModify?.Hide();
  this.PopulateOrders(true);
  }

  /*   -------------------------------------------------------------------   */

  RefreshOrdersOnBkt(bHideSel? : boolean)
  {
  if (this.bUpdateBracket == false)
    {
    return;
    }

  if (__DEV__)
    Utilities.Sendlog("Repopulating orders on Br...");

  let oSelIds : string[] = new Array(0);

  if (this.oPosData && this.obOrderRef)
    {
    for (let i = 0; i < this.obOrderRef.length; i++)
      {
      if (!bHideSel)
        this.obOrderRef[i].GetSelIds(oSelIds);

      this.obOrderRef[i].ClearAllOrders();
      }
    }


  this.PopulateOrders(true, oSelIds);

  if (bHideSel)
    this.oOBModify?.Hide();
  else
    this.oOBModify?.RePopulate(this.obOrderRef);

  this.bUpdateBracket = false;
  }

  /*   -------------------------------------------------------------------   */

  ClearAllOrders()
  {
  if (this.oPosData && this.obOrderRef)
    {
    for (let i = 0; i < this.obOrderRef.length; i++)
      {
      this.obOrderRef[i].DisableCancel(true);
      this.obOrderRef[i].ClearAllOrders();
      }
    }

  this.oOBModify?.Hide();
  }

  /*   -------------------------------------------------------------------   */

  public CenterBook() //: boolean
  {
  //this.bOBCentered = true;

  // if (this.center_current == this.center)
  //   return;

  // this.center_current = this.center;

  // Utilities.Sendlog("centering...center: " + this.center + " last: " + this.props.oData.last);
  // this.bookRef?.scrollToIndex({index:50, viewPosition:0});

  // let iItemsOffset = Math.floor( (OB.SCROLL_HEIGHT/this.ITEM_HEIGHT)/2 );

  //console.log(iItemsOffset);

  //iItemsOffset = 0;

  // this.bookRef?.scrollTo({y: (this.center - iItemsOffset ) * this.ITEM_HEIGHT,
  //                         animated:false });

  // if (this.oOBLevels && this.oOBLevels[this.center - iItemsOffset])
  //   {
  //   this.bookRef?.scrollTo({x:0,
  //                           y: this.oOBLevels[this.center - iItemsOffset].iY,
  //                           animated:false });


  //   Utilities.Sendlog("Centering To: " + this.oOBLevels[this.center - iItemsOffset].iY + " center: " + this.center + " last: " + this.props.oData.last + " item height: " + this.ITEM_HEIGHT + " window height: " + OB.SCROLL_HEIGHT);
  //   }

  //if (this.oYs[this.center] != undefined) //if (this.oYs.length >= this.center) //== this.oOBLevels?.length) //
    //{
    //let iItemsOffset = Math.floor( (this.iSCROLL_HEIGHT/this.ITEM_HEIGHT)/2 );

  let iTo = this.center - this.iOffset;

  if (this.oYs[iTo] != undefined) //if (this.oYs.length >= this.center) //== this.oOBLevels?.length) //
    {
    this.bookRef?.scrollTo({x:0,
                            y: this.oYs[iTo],
                            animated:false });


    if (__DEV__)                            
      Utilities.Sendlog("Centering To: " + this.oYs[iTo] + " center: " + this.center + " last: " + this.props.oData.last + " item height: " + this.ITEM_HEIGHT + " window height: " + this.iSCROLL_HEIGHT);

    //return(true);
    }
  else
    {
    if (__DEV__)      
      Utilities.Sendlog("Centering Failed: Ys: " + this.oYs.length + "=>" + this.oYs[this.center] + " center: " + this.center + " last: " + this.props.oData.last + " item height: " + this.ITEM_HEIGHT + " window height: " + this.iSCROLL_HEIGHT);
    }

  //return(false);  
  //if (this.center != 0)
      {
        //let iFirst = this.bookRef?.visi
      //this.bookRef?.scrollToIndex({index:50, viewPosition:0});
      //this.bookRef?.scrollToItem({item:this.props.oData.book[50]});

      //this.bookRef?.scrollToEnd();
      }
  }

  /*   -------------------------------------------------------------------   */

  manageScroll(iMsg    : number,
               oParam? : any)
  {
  switch(iMsg)
    {
    case Draggable.SCROLL_DISABLE:
      this.setState({scroll:false});
      return;
    case Draggable.SCROLL_ENABLE:
      this.setState({scroll:true});
      return;
    case Draggable.SCROLL_GO_TO:
      // this.bookRef?.scrollTo({y: oParam});
      return;
    case Draggable.SCROLL_GET_POS:
      return (this.m_y);
    }
  }

  /*   -------------------------------------------------------------------   */

  onOrderEvent (sToken?    : string,
                oOrdData?  : OrdData,
                oPosData?  : PosData,
                dRemPrice? : number,
                sBasketId? : string)
  {
  //Utilities.Sendlog("**OB Order event for: " + oOrdData.basket_id + " this.pos_data: " + this.oPosData?.acc_key);
  let bSelected   : boolean | undefined;
  let oRemOBOrder : OBOrder | undefined;

  /*   -------------------------------------------------------------------   */

  // if (this.oOBData == undefined && sToken && !oOrdData &&
  //     (this.props.oData.token == sToken || this.props.oData.trading_token == sToken))
  //   {
  //   //alert("*** FORCE update as obdata undefined ***");
  //   //this.Show();
  //   //this.preRender();

  //   return;
  //   }

  if (sBasketId)
    {
    if (this.oPosData?.orders_working)
      {
      let z = Utilities.FindString(this.oPosData?.orders_working, sBasketId);

      if (z == AppMain.IMAGINARY)
        return;

      this.bUpdateBracket = true;
      // this.RefreshOrdersOnBkt();
      }

    return;
    }

  /*   -------------------------------------------------------------------   */

  if (this.bUpdateBracket)
    {
    if (__DEV__)      
      Utilities.Sendlog("OB returning because bkt..." + sToken);

    return;
    }

  /*   -------------------------------------------------------------------   */

  if (!oOrdData || !oPosData)
    {
    if (sToken == this.oPosData?.token)
      {
      if (__DEV__)        
        Utilities.Sendlog("Repopulating orders..." + sToken);

      this.oOBModify?.Hide();

      for (let i = 0; i < this.obOrderRef.length; i++)
        this.obOrderRef[i].ClearAllOrders();

      this.PopulateOrders(true);

      //if (!this.bOBCentered)
        this.CenterBook();
      }

    return;
    }

  /*   -------------------------------------------------------------------   */

  if (this.oPosData           != oPosData ||
      oOrdData.price_type_api == PriceType.MARKET)
    return;

  /*   -------------------------------------------------------------------   */

  if (this.obOrderRef.length == 0)
    {
    if (__DEV__)      
      Utilities.Sendlog("OB Order event for: " + oOrdData.basket_id + " price levels: " + this.obOrderRef.length + " book levels: " + this.props.oData.book_levels);
    return;
    }

  /*   -------------------------------------------------------------------   */

  if (this.oOBData == undefined)
    {
    if (__DEV__)      
      Utilities.Sendlog("OB Order event for: " + oOrdData.basket_id + " OBData undefined");
    return;
    }

  /*   -------------------------------------------------------------------   */

  // switch(oOrdData.status)
  //   {
  //     case StringTable.S_COMPLETE:
  //     case StringTable.S_PENDING:
  //     case StringTable.S_MODIFIED:
  //     case StringTable.S_PARTIAL_FILL:
  //     case StringTable.S_MODRELPENDING:
  //     case StringTable.S_MODTRIGGERPENDING:
  //     case StringTable.S_STP_PENDING:
  //     case StringTable.S_REL_PENDING:
  //       break;
  //     default:
  //       return;
  //   }

  /*   -------------------------------------------------------------------   */

  if (oOrdData.linked_orders)
    {
    this.bUpdateBracket = true;
    //this.RefreshOrdersOnBkt();
    return;
    }

  /*   -------------------------------------------------------------------   */

  if (dRemPrice)
    {
    if (oOrdData.bracket_type)
      {
      this.bUpdateBracket = true;
      //this.RefreshOrdersOnBkt();

      return;
      }

    //let iLevel = ConnectionMkt.GetOBLevel(this.oOBData, dRemPrice);
    let iLvl = ConnectionMkt.GetOBLevelAlt(this.oOBLevels?
                                           this.oOBLevels[0].Price : undefined,
                                           dRemPrice,
                                           this.props.oData);

    if (iLvl != AppMain.IMAGINARY)
      {
      if (this.obOrderRef[iLvl].state.orders?.iBuyLimitBr  ||
          this.obOrderRef[iLvl].state.orders?.iSellLimitBr ||
          this.obOrderRef[iLvl].state.orders?.iBuyStopBr   ||
          this.obOrderRef[iLvl].state.orders?.iSellStopBr)
          {
          this.bUpdateBracket = true;
          // this.RefreshOrdersOnBkt();
          return;
          }

      //bSelected = this.oOBModify?.Hide(this.obOrderRef[iLevel]);
      bSelected = this.obOrderRef[iLvl].bIsSelected; //this.obOrderRef[iLvl].state.bCancel;

      if (__DEV__)
        Utilities.Sendlog("Removing OB order At: " +  oOrdData.limit_price + " sel: " + bSelected);

      this.obOrderRef[iLvl].RemoveOrder(oOrdData);

      oRemOBOrder = this.obOrderRef[iLvl];
      //this.oOBModify?.Hide(this.obOrderRef[iLevel]);
      }
    }

  /*   -------------------------------------------------------------------   */

  if (oOrdData.bracket_type)
    {
    this.bUpdateBracket = true;
    // this.RefreshOrdersOnBkt();
    return;
    }

  /*   -------------------------------------------------------------------   */

  if (oOrdData.status == "complete")
    {
    if (bSelected)
      this.oOBModify?.RePopulate(this.obOrderRef);

    return;
    }

  /*   -------------------------------------------------------------------   */

  let dPrice;

  if (oOrdData.price_type_api == PriceType.LIMIT)
    dPrice = oOrdData.limit_price;
  else
    dPrice = oOrdData.trigger_price;

  //let iLevel = ConnectionMkt.GetOBLevel(this.oOBData, dPrice);
  let iLevel = ConnectionMkt.GetOBLevelAlt(this.oOBLevels?
                                           this.oOBLevels[0].Price : undefined,
                                           dPrice,
                                           this.props.oData);

  if (iLevel != AppMain.IMAGINARY)
    {
    if (__DEV__)      
      Utilities.Sendlog("Updating OB order At: " + oOrdData.limit_price);

    this.obOrderRef[iLevel].UpdateOrder(oOrdData, false, bSelected);

    if (bSelected || this.obOrderRef[iLevel].bIsSelected) //this.obOrderRef[iLevel].state.bCancel)
      {
      this.oOBModify?.RePopulate(this.obOrderRef);
      }
      //this.oOBModify?.Show(this.obOrderRef[iLevel]);
    }
  else
    {
    if (oRemOBOrder)
      this.oOBModify?.Hide(oRemOBOrder);
    }
  }

  /*   -------------------------------------------------------------------   */

  OnConfirmApply(iMsg    : number,
                 oLevels : any)
  {
  if (iMsg != Order.MSG_CHANGE_OB_LEVELS || oLevels == undefined)
    return;

  this.props.oData.book_levels = oLevels;
  this.ClearAllOrders();
  this.forceUpdate();

  // if (this.oOBData)
  //   {
  //   this.oOBData.book_levels = oData;
  //   ConnectionMkt.RepopulateBookBlank(this.oOBData, true);
  //   }

  // if (this.props.oData.visible_index == 1)
  //   {
  //   Utilities.Sendlog("Refreshing OB: " + this.props.oData.token + " levels: " + oData);

  //   ConnectionMkt.UnSubscribeOB(this.props.oData);


  //   ConnectionMkt.SubscribeOB(this.props.oData);
  //   }
  }

  /*   -------------------------------------------------------------------   */

  componentDidMount()
  {
   //this.CenterBook();
   ConnectionOrd.BindEvent(this.onOrderEvent, true);
   this.props.bindEvent(this.UpdateData, true);

   this.props.qbRef?.current?.oOrderRef?.ApplySettings(this.OnConfirmApply.bind(this), true);
  }

  /*   -------------------------------------------------------------------   */

  componentWillUnmount()
  {
  ConnectionOrd.BindEvent(this.onOrderEvent, false);
  this.props.bindEvent(this.UpdateData, false);

  this.props.qbRef?.current?.oOrderRef?.ApplySettings(this.OnConfirmApply.bind(this), false);
  }

  /*   -------------------------------------------------------------------   */

  shouldComponentUpdate()
  {
  this.bOBCentered = false;
  this.obOrderRef.splice(0, this.obOrderRef.length);
  this.obPriceRef.splice(0, this.obPriceRef.length);

  //this.oOBModify?.Hide();
  //Utilities.Sendlog("OB shouldComponentUpdate: " + this.oPosData?.acc_key);
  return(true);
  }

  /*   -------------------------------------------------------------------   */

  onPriceLayout(event, 
                iIndex: number)
  {
    var {x, y, width, height} = event.nativeEvent.layout;

    let ht = height - 1;

    //if (this.oYs)
      this.oYs[iIndex] = y;

    // oItem.iY = y;

    //Utilities.Sendlog("OB Item: " + iIndex + " iY: " + y);

    if (this.ITEM_HEIGHT != ht && ht > 10)
      {
      this.ITEM_HEIGHT = ht;

      //if (this.oYs.length == this.oOBLevels?.length)
      //if (this.oYs[this.center] != undefined)
      }

      // if (this.bOBCentered == false)
      //   {
      //   Utilities.Sendlog("Centering on layout2...new height: " + ht)
      //   this.bOBCentered = this.CenterBook();
      //   }

      if (this.oOBLevels && this.iTotal >= this.oOBLevels?.length)//this.center)
        {
        if (this.bOBCentered == false)
          {
          this.bOBCentered = true;

          if (__DEV__)
            Utilities.Sendlog("Centering on layout2...new height: " + ht)

          this.CenterBook();
          }
        }


  }

  /*   -------------------------------------------------------------------   */

  preRender()
  {

    //if (!this.oYs.length)

    if (this.props.oData.book_levels != this.oYs.length)
      {
      this.oYs.length = this.props.oData.book_levels; //new Array(this.props.oData.book_levels); //.splice(0, this.oYs.length);
      }

    this.iTotal = 0;

    // if (this.oOBData)
    //   {
    //   if (!this.oYs || this.oYs.length != this.oOBData.book_levels)
    //     {
    //     this.oYs = new Array(this.oOBData.book_levels);
    //     }
    //   }

    if (this.oOBData == undefined || this.oOBLevels == undefined)
      {
      this.oOBData   = ConnectionMkt.GetBook(this.props.oData);
      this.oOBLevels = this.GetPartialLevels(this.oOBData);
      }
    else if (this.oOBLevels.length != this.props.oData.book_levels)
      {
      this.oOBLevels = this.GetPartialLevels(this.oOBData);

      this.bOBCentered = false;
      this.obOrderRef.splice(0, this.obOrderRef.length);
      this.obPriceRef.splice(0, this.obPriceRef.length);
      }
  }

  /*   -------------------------------------------------------------------   */

  componentDidUpdate()
  {
    //Utilities.Sendlog("Centering on componentDidUpdate...")
    //if (!this.bOBCentered)
      this.CenterBook();

    if (__DEV__)
      Utilities.Sendlog("ob component did update: " + this.props.oData.token); //OB Position data: " + this.oPosData?.acc_key);

    // if (this.bExpanding)
    //   {
    //   this.bUpdateBracket = true;  
    //   //this.RefreshOrders();  
    //   // this.RefreshOrdersOnBkt();  
    //   // if (this.oPosData && this.obOrderRef)
    //   //   {
    //   //   for (let i = 0; i < this.obOrderRef.length; i++)
    //   //     {
    //   //     this.obOrderRef[i].ClearAllOrders();
    //   //     }
    //   //   }
      
    //   this.bExpanding = undefined;  
    //   }

    
    //this.PopulateOrders(true);
    this.bUpdateBracket = true;
  }

  /*   -------------------------------------------------------------------   */

  IsCurrent(price : number)
  {
  if (this.props.oData.last)
    return(price == this.props.oData.last);
  else if (this.props.oData.close)
    return(price == this.props.oData.close);
  else if (this.props.oData.settlement)
    return(price == this.props.oData.settlement);
  else
    return(false);
  }

  /*   -------------------------------------------------------------------   */

  GetPartialLevels(oOBData : OBData | undefined) : BookItem[] | undefined
  {
  // if (this.oOBData == undefined)
  //   this.oOBData = ConnectionMkt.GetBook(this.props.oData);

  /*   -------------------------------------------------------------------   */

  if (!oOBData)
    return(undefined);

  /*   -------------------------------------------------------------------   */

  let iMid = AppMain.IMAGINARY;

  if (this.props.oData.last)
    iMid = ConnectionMkt.GetOBLevel(oOBData.book[0].Price,
                                    this.props.oData.last,
                                    this.props.oData.qpc,
                                    oOBData.book_levels);

  if (iMid == AppMain.IMAGINARY)
    iMid = Utilities.round((oOBData.book.length/2), 0);

  let iLvl = Utilities.round((this.props.oData.book_levels/2), 0);
  let oList : BookItem[] = new Array(0);

  /*   -------------------------------------------------------------------   */

  let iStart = iMid - iLvl;

  if (iStart < 0)
    iStart = 0;

  let iEnd   = iMid + iLvl;

  if (iEnd >= oOBData.book.length)
    iEnd = oOBData.book.length;

  for (let i = iStart, j = iEnd; i < j; i++)
      {
      oList.push(oOBData.book[i]);
      }

  /*   -------------------------------------------------------------------   */

  //this.center  = ConnectionMkt.GetOBLevel(oOBData.book[0].Price, this.props.oData.last, this.props.oData); //Utilities.round((oList.length/2), 0);

  /*   -------------------------------------------------------------------   */

  if (oList.length > 0)
    {
    //this.dAnchor = oList[0].Price;
    this.center  = ConnectionMkt.GetOBLevelAlt(oList[0].Price,
                                               this.props.oData.last,
                                               this.props.oData);
    }
  else
    {
    //this.dAnchor = undefined;
    this.center  = AppMain.IMAGINARY;
    }

  return(oList);
  }

  /*   -------------------------------------------------------------------   */

  private oYs     : number[]  = new Array(0);
  private iTotal  : number    = 0;
  private iOffset : number   = 0;

  render()
  {
    //this.obOrderRef.splice(0, this.obOrderRef.length);
    this.preRender();


    if (this.state.visible == false)
      {
      //Utilities.Sendlog("**OB not initialized: " + this.props.oData.token);
      return(
        null
      );
      }
    else
    {
    //Utilities.Sendlog("**OB initializing: " + this.props.oData.token);
    return (
      <View style={{backgroundColor:'transparent'}}>


      <OBModify ref={node=>{this.oOBModify = node}} bindEvent={this.props.bindEvent} oOBData={this.oOBData}/>

      {/* <View style={[styles.container, {height: this.state.height? this.state.height + 5 : 375}]}>  */}
      <View style={[styles.container, {height: this.state.height + 5}]}>

      <TouchableOpacity style={{position:'absolute', right:24, top:2, zIndex:21}}
        onPress={()=>
          {
          this.bExpanded = !this.bExpanded;
          this.obMaxButton?.Expanded(this.bExpanded);
          
          if (this.bExpanded)
            {
            this.obTop?.Hide();
            this.obBottom?.Hide();
            
            }
          else
            {
            this.obTop?.Show();
            this.obBottom?.Show();
            }

          // this.bExpanding = true;

          // if (this.oPosData && this.obOrderRef)
          // {
          // for (let i = 0; i < this.obOrderRef.length; i++)
          //   {
          //   this.obOrderRef[i].ClearAllOrders();
          //   }
          // }

          // this.setState({expanded: !this.state.expanded});

          ConnectionOrd.SaveSettingsSymbol({token: this.props.oData.token, 
                                            bOBExpanded: this.bExpanded});
                                            //bOBExpanded:!this.state.expanded});

          }}>

      <OBMaxButton ref={(node)=> {this.obMaxButton=node}} expanded={this.bExpanded }  />      
      {/* <Feather style={{}} name="maximize-2" size={20} color={this.bExpanded? FontInfo.sLightGreen : FontInfo.sDimGrayTp} />   */}
      
      </TouchableOpacity>

      <OBTop ref={(node)=> {this.obTop=node}} visible={!this.bExpanded } iWDelta={OB.iWDelta} qbRef={this.props.qbRef} oData={this.props.oData} bindEvent={this.props.bindEvent}/>


      {/* <TouchableOpacity onPress={()=>{ConnectionMkt.UnSubscribeOB(this.props.oData); ConnectionMkt.SubscribeOB(this.props.oData)}} style={{alignItems:'center', justifyContent:'center', backgroundColor:'gainsboro', borderRadius:5, width:30, height:30, position:'absolute', left:6, top:2}}>
      <Foundation name="arrows-in" size={16} color="white" />
        </TouchableOpacity> */}

       {/* <View style={{marginLeft:130 - OB.iWDelta, marginBottom:2, width:75 - OB.iWDelta, backgroundColor:'transparent', alignItems:'center', flexDirection:'column'}}> */}
      
       {/* <OBNakedText bindEvent={this.props.bindEvent}
                    getStyle={()=>{return([styles.row_mode, {color: Utilities.getModeColor(this.props.oData.mode)}])}}
                    getText={()=>{return(this.props.oData.mode)}}
                    /> */}



        {/* <OBNakedText bindEvent={this.props.bindEvent}
                    getStyle={()=>{return(this.props.oData.pc >= 0? styles.title_small_green : styles.title_small_red)}}
                    getText={()=>{return(this.props.oData.nc < 0? ConnectionMkt.getFmt(this.props.oData.nc, this.props.oData) : "+" + ConnectionMkt.getFmt(this.props.oData.nc, this.props.oData))}}
                    /> */}

        {/* <View style={{display:this.state.expanded?'none':'flex', marginLeft:-14, marginBottom:2, minWidth:75 - OB.iWDelta, backgroundColor:'transparent', alignItems:'center', flexDirection:'column'}}>

        <OBNakedText
                    bindEvent={this.props.bindEvent}
                    getStyle={()=>{return(this.props.oData.pc >= 0?
                      [FontInfo.appStyles.txt_bold, {color:FontInfo.sGreen}] : [FontInfo.appStyles.txt_bold, styles.title_small_red])}}
                    getText={()=>{return(this.props.oData.vol == 0? " " : this.props.oData.vol.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,'))}}
                    />

        <OBChange
                    bindEvent={this.props.bindEvent}
                    getStyle={()=>{return(this.props.oData.pc >= 0?
                      [FontInfo.appStyles.txt_bold, styles.title_small_green_bg, {backgroundColor:FontInfo.sGreen}] : [FontInfo.appStyles.txt_bold, styles.title_small_red_bg])}}
                    style={[FontInfo.appStyles.txt_bold, styles.title_small_text]}
                    getText={()=>{return(this.props.oData.nc < 0? ConnectionMkt.getFmt(this.props.oData.nc, this.props.oData) : "+" + ConnectionMkt.getFmt(this.props.oData.nc, this.props.oData))}}
                    />

       </View> */}

      <ScrollView style={{}}  nestedScrollEnabled ref={node => { this.bookRef = node} }
        // onScroll = { (event) => { this.m_y = event.nativeEvent.contentOffset.y } }
        onLayout={(event) => {
          var {x, y, width, height} = event.nativeEvent.layout;

          if (this.iSCROLL_HEIGHT != height && height > 100)
            {
            this.iSCROLL_HEIGHT = height;
            this.iOffset        = Math.floor( (this.iSCROLL_HEIGHT/this.ITEM_HEIGHT)/2 );
            //alert(OB.SCROLL_HEIGHT);

            if (__DEV__)
              Utilities.Sendlog("Centering on layout..." + this.iSCROLL_HEIGHT);

            //if (!this.bOBCentered)
             this.CenterBook();
            }
        }}
        >
        {
        this.oOBLevels?.map((oItem:BookItem, iIndex:number)=>{
          return (
                  <View key={iIndex} 
                   style= {{flex: 1, backgroundColor: 'transparent', justifyContent: 'center', paddingLeft: 0, marginTop:-1,}}
                     //{styles.listItem}
                   onLayout={(event) => 
                    {
                      //this.onPriceLayout(event, iIndex);

                      var {x, y, width, height} = event.nativeEvent.layout;

                      let ht = height - 1;
                  
                      //if (this.oYs)
                      this.oYs[iIndex] = y;
                  
                      // oItem.iY = y;
                      this.iTotal++;

                      //Utilities.Sendlog("OB Item: " + iIndex + " so far: " + this.iTotal+ " iY: " + y + " Ys=>" + this.oYs[iIndex]);
                  
                      if (this.ITEM_HEIGHT != ht && ht > 10)
                        {
                        this.ITEM_HEIGHT = ht;
                        this.iOffset     = Math.floor( (this.iSCROLL_HEIGHT/this.ITEM_HEIGHT)/2 );
                        
                        //if (this.oYs.length == this.oOBLevels?.length)
                        //if (this.oYs[this.center] != undefined)
                        }
                  
                      if (this.oOBLevels && this.iTotal >= this.oOBLevels?.length)//this.center)
                        {
                        if (this.bOBCentered == false)
                          {
                          this.bOBCentered = true;

                          if (__DEV__)
                            Utilities.Sendlog("Centering on layout2...new height: " + ht)
                            
                          this.CenterBook();
                          }
                        }
                  
                    }}>
                  <View style={[{borderWidth:0, flexDirection:'row', backgroundColor:'transparent', }]}>
                  {/* <Text style={{color:'black', fontSize:20}}>{item.x?.toString()}</Text> */}

                  {/* <View style={{minWidth:50, backgroundColor:'dodgerblue'}}> */}

                  <OBOrder ref={node => { if (node) this.obOrderRef.push(node)}}  oBookItem={oItem} oOB={this} /*manageScroll={this.manageScroll.bind(this)} */  />

                  <OBStaticStyleText
                          style={[FontInfo.appStyles.txt_semibold, {margin:0, paddingRight:3, color:'white', textAlign:'right'}]}
                          getText={()=>{return(oItem.BidSize == 0? "" : oItem.BidSize.toString())}}
                          color={'dodgerblue'}
                          iWDelta={OB.iWDelta}
                          bindEvent={this.props.bindEvent}
                          item={oItem}
                          //min_width={50}
                          onClick={this.onClickBuy}
                          />
                  {/* </View> */}

                  <View style={{minWidth:75 - OB.iWDelta, marginHorizontal:6, backgroundColor:'transparent',}}>
                  <OBLastPrice ref={node => { if (node) this.obPriceRef.push(node)}}
                  style={[FontInfo.appStyles.txt_semibold, {margin:0, textAlign:'center'}]}
                  getText={()=>{return(oItem.PriceKey)}}
                  IsCurrent={()=>{return(oItem.PriceKey != "" && this.IsCurrent(oItem.Price))}}
                  bindEvent={this.props.bindEvent}
                  index={iIndex}
                  setCenter={this.SetCenter}
                  goCenter={this.CenterBook}
                  />
                  </View>

                  <OBStaticStyleText
                          style={[FontInfo.appStyles.txt_semibold, {color:'white', textAlign:'left'}]}
                          getText={()=>{return(oItem.AskSize == 0? "" : oItem.AskSize.toString())}}
                          color={'hotpink'}
                          iWDelta={OB.iWDelta}
                          bindEvent={this.props.bindEvent}
                          //min_width={50}
                          item={oItem}
                          onClick={this.onClickSell}
                          />

                    {/* <OBStaticStyleText
                          style={[FontInfo.appStyles.txt_normal, {fontSize:FontInfo.iFontSize-2, color:'hotpink', textAlign:'right', }]}
                          getText={()=>{return(oItem.AskSize == 0? "" : oItem.AskSize.toString())}}
                          color={'hotpink'}
                          iWDelta={OB.iWDelta}
                          min_width={30}
                          bindEvent={this.props.bindEvent}
                          item={oItem}
                          is_fg={true}
                          />

                    <OBStaticStyleText
                          style={[FontInfo.appStyles.txt_normal, {fontSize:FontInfo.iFontSize-2, color:'dodgerblue', textAlign:'right'}]}
                          getText={()=>{return(oItem.BidSize == 0? "" : oItem.BidSize.toString())}}
                          color={'hotpink'}
                          iWDelta={OB.iWDelta}
                          min_width={30}
                          bindEvent={this.props.bindEvent}
                          item={oItem}
                          is_fg={true}
                          />                           */}


                  </View>
                  </View>

                 );
                 })
        }
      </ScrollView>


      <OBBottom ref={(node)=> {this.obBottom=node}} visible={!this.bExpanded } qbRef={this.props.qbRef} oData={this.props.oData} bindEvent={this.props.bindEvent}/>


       {/* <View style={{display:this.state.expanded?'none':'flex', flexDirection:'column'}}>
       <OrderWoOrder
       ref={node => { this.orderWoOrderRef = node}}
       oData={this.props.oData}
       qbRef={this.props.qbRef}
       bindEvent={this.props.bindEvent}
       />

       <OBNakedText bindEvent={this.props.bindEvent}
                    getStyle={()=>{return([FontInfo.appStyles.txt_bold, styles.row_mode, {marginLeft:0, color: Utilities.getModeColor(this.props.oData.mode)}])}}
                    getText={()=>{return(this.props.oData.mode)}}
                    />

       </View> */}


       {/* <Text3 name = "" bbb={this.props.bindEvent} getstyle={()=>{return([styles.row_mode, {color: Utilities.getModeColor(this.props.oData.mode)}])}} ggg={()=>{return(this.props.oData.mode)}}></Text3> */}
      </View>
      </View>
    );
    }
  }
}

/*   ---------------------------------------------------------------------   */

const styles = StyleSheet.create({
  container: {
    marginTop: 4,
    //flex:1,
    backgroundColor: 'transparent',
  },

  listItem: {
    flex: 1,
    backgroundColor: 'transparent',
    justifyContent: 'center',
    paddingLeft: 0,
    marginTop:-1,
  },

  // row_mode: {
  //   alignSelf:'center',
  //   color: 'grey',
  //   marginTop:2,
  //   paddingRight: ConnectionMkt.DEVICE_NAME == ConnectionMkt.DEVICE_WEB? 15 : 0,
  //   },

  // title_small_green: {
  //   color: 'green',
  // },

  // title_small_red: {
  //   color: 'red',
  // },

  // title_small_green_bg: {
  //   backgroundColor: 'green',

  //   borderRadius: 4,
  //   paddingRight:2,
  // },

  // title_small_red_bg: {
  //   backgroundColor: 'red',

  //   borderRadius: 4,
  //   paddingRight:2,
  // },

  // title_small_text: {
  //   flexWrap:'nowrap',
  //   marginLeft:2,
  //   color: 'white',
  //   backgroundColor: 'transparent',
  // },

});

